import Reflux from 'reflux';
import panelActions from '../action/panelActions';

export default Reflux.createStore({
  listenables: panelActions,
  onTogglePanel(type = '', shortcodeKey = '', parentUid = '', childUid = '') {
    const key = 'panel_' + shortcodeKey;
    window.openWindow[key] = !window.openWindow[key];
    this.trigger(window.openWindow[key], type, shortcodeKey, parentUid, childUid);
  },
});



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/panel/store/togglePanelStore.js
 **/